import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import {theme} from '../tailwind.config.js';
import ContentfulVue from 'contentful-vue';
import VueCoreVideoPlayer from 'vue-core-video-player';
import NProgress from 'vue-nprogress'

require('./global-components');

Vue.config.productionTip = false;

Vue.use(ContentfulVue, {
    space: 'z8ra8b5cf9er',
    accessToken: 'K5oKMR6eBk68NjqoXyiCL725MoJ1ogSCTFUV4X5CUZY'
});

Vue.prototype.$globalLoading = {active: false};
Vue.prototype.$token = 'Mpm9RRY12k8kEjuuFuN67YMOLKpjTWcT';

Vue.use(VueCoreVideoPlayer);

Vue.use(NProgress)
const nprogress = new NProgress()

new Vue({
    router,
    nprogress,
    render: h => h(App)
}).$mount('#app');

Vue.prototype.$theme = theme;

Vue.prototype.$navigate = function (href, target) {
    const l = document.createElement("a");
    l.href = href;


    //Normal routing

    if (target) {
        setTimeout(() => {
            window.open(href, target);
        }, 0);
    } else {
        setTimeout(() => {
            location.href = href;
        }, 0);
    }
};



